import labels from '../../../constants/labels';

export const contactsDirectoryProp = {
  tableNm: 'FXG_External_Contact_Information_Directory',
  tableHeading: 'Contacts Directory',
  resultsLabel: 'Results',
  isDisplayTableHeading: false,
  clientEndOperation: true,
  errMsg: 'Internal Server Error. Please Try again',
  checkable: false,
  singleRowSelect: false,
  maxRowSelection: 1,
  inlineItemAction: false,
  maxRowSelectionErrMsg: 'Maximum limit of 1 record reached',
  emptyDataMsg: 'No data found',
  headers: [
    {
      sNo: 1,
      id: 'userFullName',
      label: labels.CONTACT_NM,
      display: true,
      filter: '',
    },
    {
      sNo: 2,
      id: 'userEmailId',
      label: labels.CONTACT_EMAIL,
      display: true,
      filter: '',
    },
    {
      sNo: 3,
      id: 'contactType',
      label: 'Contact Type',
      display: true,
      filter: '',
    },
    {
      sNo: 4,
      id: 'digitalAssetGroup',
      label: labels.DIGITAL_ASSETS_GROUP,
      display: true,
      filter: '',
    },
    {
      sNo: 5,
      id: 'environment',
      label: labels.ENVIRONMENT,
      display: true,
      filter: '',
    },
  ],
  currentPage: 1,
  showLoader: true,
  showError: false,
  totalRows: 0,
  sortable: true,
  sortBy: 'userFullName',
  sortDirection: 'asc',
  rowKeyCol: 'rowId',
  selection: { preview: false },
  itemsPerPage: 5,
  showFilter: false,
  rows: [],
  selectedRows: {},
  selectedRowsData: {},
  actionList: [
    // {
    //   label: 'Update Contact',
    //   id: 'update_contact',
    //   sNo: 1,
    // },
  ],
};

export const amexContactsDirectoryProp = {
  tableNm: 'FXG_AXP_Contact_Information_Directory',
  tableHeading: 'Contacts Directory',
  resultsLabel: 'Results',
  isDisplayTableHeading: false,
  clientEndOperation: true,
  errMsg: 'Internal Server Error. Please Try again',
  checkable: false,
  singleRowSelect: false,
  maxRowSelection: 1,
  maxRowSelectionErrMsg: 'Maximum limit of 1 record reached',
  emptyDataMsg: 'No data found',
  headers: [
    {
      sNo: 1,
      id: 'userFullName',
      label: labels.CONTACT_NM,
      display: true,
      filter: '',
    },
    {
      sNo: 2,
      id: 'userEmailId',
      label: labels.CONTACT_EMAIL,
      display: true,
      filter: '',
    },
    {
      sNo: 3,
      id: 'contactType',
      label: 'Contact Type',
      display: true,
      filter: '',
    },
    {
      sNo: 4,
      id: 'digitalAssetGroup',
      label: labels.DIGITAL_ASSETS_GROUP,
      display: true,
      filter: '',
    },
    {
      sNo: 5,
      id: 'environment',
      label: labels.ENVIRONMENT,
      display: true,
      filter: '',
    },
  ],
  currentPage: 1,
  showLoader: true,
  showError: false,
  totalRows: 0,
  sortable: true,
  sortBy: 'userFullName',
  sortDirection: 'asc',
  rowKeyCol: 'rowId',
  selection: { preview: false },
  itemsPerPage: 5,
  showFilter: false,
  rows: [],
  selectedRows: {},
  selectedRowsData: {},
};
